<template>
<!-- 지원 접속 탭이면 모든 화면 위에 배너(닫기 없음, 사이드 메뉴가 없는 화면에도) -->
<SupportBanner v-if="supportTab" />
<img src="@/assets/img/login/finger-pointer.png" class="finger-pointer"  >
<router-view v-if="isCustomPage"/>
<div v-if="!isCustomPage">
    <LoadingSpinner v-if="$store.state.isLoading"/>
    <sidenav :class="['fixed-start']" v-if="$store.state.showSidenav" />
    <!-- 첫 로그인 「고객 지원을 위한 접근 허용」 꼭 고르기 창 — 로그인 뒤 껍데기가 뜰 때 한 번 확인(어느 화면으로 들어와도) -->
    <SupportConsentCard mode="choice" />
    <!--
      폰 상단 홈 바.

      하단 탭이 유일한 이동 수단인데 제조사가 대시보드를 탭에서 뺄 수 있으므로,
      그런 구성에서는 대시보드로 돌아갈 방법이 없어진다. 로고를 눌러 돌아간다.
      탭이 아니라 로고라 "탭만 둔다"는 방침과 충돌하지 않는다.

      원래 여기 있던 mobile_header 는 조건이 $route.path.includes('mobile') 이었는데
      'mobile' 을 포함하는 라우트가 하나도 없어 한 번도 뜬 적이 없었다. 그것을 대체한다.
    -->
    <header v-if="showMobileHomeBar" class="mobile-home-bar" @click="goHome">
        <img src="@/assets/img/certilogo.png" class="mobile-home-logo" alt="CertiLife">
    </header>

    <!--
      상단 여백은 헤더가 실제로 그려질 때만 준다.

      common.scss 가 폰에서 .main-content 에 padding-top 을 주는데, 그것은 바가
      있다는 전제다. 바를 숨기는 경우가 둘(구버전 앱 · 자기 앱바를 가진 화면)이라
      조건이 흩어지면 '헤더는 없는데 빈 띠가 남는' 어긋남이 생긴다.
      showMobileHomeBar 하나만 보게 묶어 두면 구조적으로 어긋날 수 없다.
    -->
    <main
        class="main-content position-relative max-height-vh-100 h-100"
        :class="{ 'no-home-bar': !showMobileHomeBar }"
    >
        <router-view v-if="!isCustomPage"/>
        <!--
          하단 탭이 본문 끝을 가리지 않게 자리를 만든다.

          .main-content 에 padding-bottom 을 주는 방법은 이 요소에서 먹지 않는다 —
          !important 로 넣어도 scrollHeight 가 그대로였다(실측). 스크롤 컨테이너가
          이 요소라 패딩이 스크롤 영역에 반영되지 않는 것으로 보인다.
          빈 요소는 어떤 경우에도 자리를 차지하므로 확실하다.

          조건은 '폰인가' 가 아니라 '탭이 실제로 그려지는가' 다 —
          설정을 안 한 제조사는 탭이 없는데 여백만 남으면 안 된다.
        -->
        <div v-if="hasMobileTab" class="mobile-tab-spacer" aria-hidden="true"></div>
    </main>

    <!-- 하단 탭. 구성은 운영페이지에서 제조사가 정한다. -->
    <mobile-tab-bar v-if="showMobileChrome" />
</div>
<!-- MFA_REQUIRED·SEND_AUTH_REQUIRED 를 받은 요청이 여는 인증번호 창(axios.js) -->
<OtpVerifyModal ref="stepUpModal" />
<!-- 직원 권한 정기 확인(6개월): 로그인 뒤 껍데기에서 탭·계정마다 한 번, 로그아웃하면 표시를 지움(T-CONTRACT-1031 §2) -->
<PermReviewModal :active="!isCustomPage" />

</template>
<script>
import { getAccessToken, getRefreshToken, isSupportEnded, isSupportTab } from '@/utils/tokenStore';
import Sidenav from './views/components/Sidenav';
import LoadingSpinner from '@/views/components/Loading.vue';
import MobileTabBar from '@/views/components/MobileTabBar.vue';
import OtpVerifyModal from '@/views/components/OtpVerifyModal.vue';
import SupportBanner from '@/views/components/SupportBanner.vue';
import SupportConsentCard from '@/views/components/SupportConsentCard.vue';
import PermReviewModal from '@/views/components/PermReviewModal.vue';
import { SUPPORT_ENDED_PATH, SUPPORT_ENTER_PATH, isSupportPagePath } from '@/utils/supportSession';
import { ENTER_PATH } from '@/utils/handoff';
import { setStepUpHandler } from '@/utils/mfa';
import { setPermReloadHandler } from '@/utils/standardErrors';
import {
    oneBtnDialog,
    resetWrongTokens,
    jwtDecoder,
} from './utils/utils';
import { bridges } from '@/utils/bridges';
import { canOpen } from '@/router';
import { appDrawsNativeHeader, isLegacyHostApp } from '@/utils/deviceCheck';
import { receiveNativeScanResult } from '@/utils/nativeScanner';


// import { ConfigProvider } from 'ant-design-vue';

export default {
    name: 'App',
    setup() {
        const antDesignConfig = {
            form: {
                colon: false,
            }
        }
        return {
            antDesignConfig
        }
    },
    components: {
        Sidenav,
        LoadingSpinner,
        MobileTabBar,
        OtpVerifyModal,
        SupportBanner,
        SupportConsentCard,
        PermReviewModal,
        // ConfigProvider,
    },
    data() {
        return {
            isInternetConnected: true,
            role: 'MANUFACTURER',
            pollingTimer: null,
            interval: process.env.NODE_ENV === 'production' ? 3600000 : 60000,
            isMobileView: window.innerWidth < 768,
            /*
             * 로그인 여부. computed 가 아니라 data 인 이유가 있다.
             *
             * 원래는 computed 에서 localStorage 를 바로 읽었는데, localStorage 는
             * 반응형이 아니라 의존성이 하나도 없는 computed 가 된다. Vue 는 무효화할
             * 근거가 없으므로 최초 1회 계산한 값을 계속 돌려준다.
             *
             * 그래서 /signin 에서 false 로 굳은 뒤 로그인해도 false 로 남아,
             * 하단 탭과 상단 홈 바가 새로고침 전까지 뜨지 않았다.
             * 아래 $route 워처에서 갱신한다 — 로그인은 곧 라우터 이동이라 그때 잡힌다.
             */
            hasAccessToken: !!getAccessToken(),
            // 지원 탭은 진입·끝에서 늘 새로 고치므로 처음 한 번 읽으면 됨
            supportTab: isSupportTab() && !isSupportEnded(),
        };
    },
    created() {
        console.log('created')
        resetWrongTokens();

        this.loadWebChatSDK();
        this.setLiveVersionObserver();

        const mediaQuery = window.matchMedia('(max-width: 767px)');
        const mediaQuery2 = window.matchMedia(
        '(min-width: 768px) and (max-width:1370px)'
        );
        mediaQuery.addListener(this.handleDeviceChange);
        mediaQuery2.addListener(this.handleDeviceChange);
        this.handleDeviceChange(mediaQuery);
        this.handleDeviceChange(mediaQuery2);

        // 지원 진입·끝·앱 사이 이동 받기 화면에선 부르지 않음(교환 전 일반 토큰으로 읽은 회사 값이 지원 탭에 남지 않게)
        const entryPage = isSupportPagePath(window.location.pathname) || window.location.pathname === ENTER_PATH;
        if(getAccessToken() && !entryPage) this.$store.dispatch('getCompanyInfo', this);
        window.addEventListener('storage', this.handleStorageChange);
        window.addEventListener('resize', () => {
            this.isMobileView = window.innerWidth < 768;
            // 창을 좁혀 폰 폭이 되면 그때 설정을 받는다. PC 폭에서는 요청 자체를 하지 않는다.
            this.loadMobileTabsIfNeeded();
        });

    },
    beforeUnmount() {
        window.removeEventListener('storage', this.handleStorageChange);
    },
    beforeMount(){
    },
    async mounted() {
        const thisObj = this;
        this.initBridges();
        this.checkHasAccessToken();
        this.setOnlineObserver();
        setStepUpHandler(purpose => this.$refs.stepUpModal.start({ mode: 'stepUp', purpose }));
        // 403 PERMISSION_DENIED 뒤 권한 값(introspect)을 한 번 다시 읽음(axios). 처음 읽기는 사이드 메뉴가 함
        setPermReloadHandler(() => this.$store.dispatch('loadIntrospect'));
        // 하단 탭 구성 로드는 위 $route 워처(immediate)가 맡는다.
        // 여기서 또 부르면 마운트 때 요청이 두 번 나간다.
        window.addEventListener('wheel', preventScroll, { passive: false });
        window.addEventListener('touchmove', preventScroll, { passive: false });
        window.addEventListener('keydown', (event) => {
            // Page Up (33), Page Down (34), End (35), Home (36), Arrow keys (37-40), Space (32)
            if ([32, 33, 34, 35, 36, 37, 38, 39, 40].includes(event.keyCode)) {
                if(thisObj.$store.state.isLoading === true){
                    event.preventDefault();
                }
            }
        });
        function preventScroll(event) {
            if(thisObj.$store.state.isLoading === true){
                event.preventDefault();
            }
        }
    },
    computed: {
        isCustomPage() {
            const specialRoutes = ['/mobile', '/signin', '/reset-pwd', SUPPORT_ENTER_PATH, SUPPORT_ENDED_PATH, ENTER_PATH];
            return specialRoutes.includes(this.$route.path.toLowerCase());
        },
        /**
         * 폰 전용 요소(상단 로고 바 · 하단 탭)를 그릴지.
         * 로그인 화면·비밀번호 재설정에서는 둘 다 나오면 안 되므로
         * 두 요소가 같은 조건을 쓰게 묶어 둔다.
         */
        showMobileChrome() {
            if (!this.isMobileView || !this.hasAccessToken || this.isCustomPage) return false;
            /*
             * 구버전 앱은 네이티브 하단 탭을 갖고 있다. 여기서 웹 탭까지 그리면
             * 두 줄로 겹쳐 보인다 — 실제로 운영에서 이 증상이 나 롤백했다.
             *
             * 앱 심사를 기다리지 않고 웹만으로 막기 위해 여기서 가른다.
             * 사용자가 앱을 업데이트하지 않아도 자동으로 커버된다.
             *
             * 이 분기가 false 가 되면 showMobileHomeBar 와 hasMobileTab 도
             * 같이 꺼진다 — 그 둘이 이 값을 보기 때문이다. 의도한 바다:
             * 구버전 앱에서는 폰 전용 요소를 하나도 그리지 않는다.
             */
            if (isLegacyHostApp()) return false;
            return true;
        },
        /**
         * 상단 홈 바를 그릴지. 하단 탭과 조건이 갈린다.
         *
         * 예전에는 앱 안에서 네이티브 내비게이션 바가 CertiLife 로고를 그려서
         * 로고가 두 번 겹쳤고, 그래서 앱이면 무조건 웹 쪽을 숨겼다.
         *
         * 이제는 앱이 그 바를 걷었는지 UA 토큰으로 물어본다(appDrawsNativeHeader).
         * 아직 걷지 않은 구버전 앱에서는 예전처럼 숨겨 겹치지 않게 한다.
         *
         * 모바일 브라우저에서는 그대로 둔다 — 거기엔 네이티브 헤더가 없어서
         * 이걸 숨기면 로고도, 대시보드로 돌아가는 유일한 경로(goHome)도 사라진다.
         *
         * 앱에서도 그 복귀 경로가 살아난다 — 예전에는 앱이면 무조건 숨겨서 포기했었다.
         * 대시보드를 하단 탭에 넣지 않은 제조사는 앱에서 대시보드에 갈 수 없었는데,
         * 앱이 네이티브 바를 걷은 뒤로는 이 로고가 그 경로를 되돌려 준다.
         */
        showMobileHomeBar() {
            if (!this.showMobileChrome || appDrawsNativeHeader()) return false;
            return !this.routeHidesHomeBar;
        },
        /**
         * 지금 화면이 라우트 정의에서 로고 바를 끄라고 했는가 — meta.hideHomeBar.
         *
         * 어느 화면에서 끌지는 router/index.js 가 정한다. 여기서는 경로를 모른다.
         * 로고 바를 없앨 화면이 늘면 그 라우트에 meta 한 줄만 달면 되고,
         * 이 파일은 고칠 필요가 없다. 여백·셸 높이·전환도 이 값 하나를 따라간다.
         *
         * vue-router 는 부모 라우트의 meta 를 자식에게 합쳐 준다(자식 값이 우선).
         * 그래서 흐름 전체에 한 번 달고 예외 화면에서만 false 로 끈다 — 정품 라벨이 그렇다.
         *
         * 라우트로 가르는 이유: 화면 쪽에서 플래그를 올리면 마운트 순서에 따라
         * 한 프레임 깜빡인다. 라우트는 이동이 끝나기 전에 정해져 그 문제가 없다.
         */
        routeHidesHomeBar() {
            return this.$route.meta?.hideHomeBar === true;
        },
        /**
         * 하단 탭이 실제로 그려지는지. 본문 아래 여백을 줄지 정하는 데 쓴다.
         * MobileTabBar 와 같은 getter·같은 기준(1개 이상)을 본다 —
         * 두 곳이 어긋나면 '바는 없는데 여백만 남거나' 그 반대가 된다.
         */
        hasMobileTab() {
            if (!this.showMobileChrome) return false;
            return this.$store.getters.getVisibleMobileTabs.length > 0;
        },
    },
    watch:{
        "$route": {
            immediate: true,
            deep: true,
            handler(newValue, oldValue) {
               // 토큰 상태를 먼저 맞춘다 — 아래 loadMobileTabsIfNeeded 가 이 값을 본다.
               this.hasAccessToken = !!getAccessToken();
               this.currentPageName = newValue.fullPath
               this.loadMobileTabsIfNeeded();
            },
        },
    },
    methods: {
        /**
         * 하단 탭 구성을 받아 둔다. 라우터 이동과 창 크기 변경에서 부른다.
         *
         * mounted 에서만 부르면 로그인 직후에는 못 받는다 — 로그인은 라우터 이동일 뿐이라
         * App.vue 가 다시 마운트되지 않고, 로그인 화면으로 처음 들어온 사용자는
         * mounted 시점에 토큰이 없다. 그러면 새로고침 전까지 탭 바가 뜨지 않는다.
         *
         * PC 폭에서는 요청하지 않는다 — 하단 탭은 폰 전용이고,
         * PC 동작을 한 줄도 바꾸지 않기로 했다.
         *
         * '받았는가' 가 아니라 '어느 회사 것을 받았는가' 로 판단한다.
         * 로그아웃은 store 를 비우지 않으므로(clearLocalStorage 는 localStorage 만 지운다),
         * 단순히 받았는지만 보면 다른 계정으로 다시 로그인했을 때 이전 제조사의 탭이 남는다.
         */
        loadMobileTabsIfNeeded() {
            if (!this.isMobileView || !this.hasAccessToken) return;
            let companyId = null;
            try {
                companyId = jwtDecoder(getAccessToken());
            } catch (error) {
                return;
            }
            if (!companyId) return;
            if (this.$store.getters.getMobileTabsCompanyId === companyId) return;
            this.$store.dispatch('getMobileTabs');
        },
        /**
         * 상단 로고 → 대시보드.
         *
         * 제조사가 대시보드를 하단 탭에서 뺄 수 있어서, 그런 구성에서는
         * 이 경로가 대시보드로 돌아가는 유일한 방법이다.
         */
        goHome() {
            // 대시보드를 못 여는 직원은 첫 탭(경유 화면)으로 — 로고가 「권한 없음」으로 튕기지 않게(라우터와 같은 판정)
            if (!canOpen('/dashboard')) this.$router.push('/landing');
            else if (this.$route.path !== '/dashboard') this.$router.push('/dashboard');
        },
        handleStorageChange(event) {
            // 지원 탭은 그 탭 sessionStorage 만 씀 — 다른 탭의 일반 로그인·로그아웃(localStorage 바뀜)에 따라 새로 고치지 않음
            if (isSupportTab()) return;
            if(event.key === 'manufacturerNameManu') {
                if(event.newValue) {
                    window.location.reload();
                }
            }
            if (event.key === 'accessTokenManu') {
                if (!event.newValue) {
                    window.location.reload();
                }
            }
        },
        initBridges() {
            window.appToWeb = bridges().appToWeb;
            window.webToApp = bridges().webToApp;
            window.checkIsLoggedIn = bridges().checkIsLoggedIn;
            window.requestLogoutFromApp = bridges().requestLogoutFromApp;

            /*
             * 앱 번들 버전 수신구.
             *
             * 마이페이지의 '버전 정보' 행이 이 값을 보고 나타난다. 앱 번들 버전이라
             * 웹이 스스로 알 수 없어서, 앱이 페이지 로드를 마친 뒤 이 함수를 부른다
             * (iOS BasicWebViewController, 안드로이드 ManufacturerWebViewFragment).
             * 값이 없으면 그 행 자체를 그리지 않으므로 모바일 브라우저에는 안 보인다.
             *
             * store 에 넣는 이유: 앱이 언제 부를지 화면이 알 수 없다. 전역 변수에 담고
             * 화면이 한 번만 읽으면, 마이페이지가 먼저 만들어진 경우 값이 없는 채로 굳는다.
             */
            window.setAppVersion = (version) => {
                this.$store.commit('setAppVersion', version || null);
            };

            /*
              네이티브 스캐너의 결과를 받는 자리.

              앱이 evaluateJavascript 로 이 함수를 부른다. 두 화면(라벨 QR·제품코드)이
              같은 통로를 쓴다 — 스캐너는 전체 화면이라 둘이 동시에 열릴 수 없고,
              기다리는 요청도 하나뿐이다(nativeScanner.js).

              앱이 이 메서드를 갖고 있는지는 화면 쪽에서 hasNativeScanner() 로 먼저 본다.
              여기 붙여 두는 것은 「앱이 결과를 돌려줄 곳」이라 앱 유무와 무관하다.
            */
            window.requestAppToWeb_ScanQR_Label = receiveNativeScanResult;
            window.requestAppToWeb_ScanProductCode = receiveNativeScanResult;
        },
        async setLiveVersionObserver() {
            await this.getLiveVersion();

            if(!this.isInternetConnected) return;
            if(this.pollingTimer) return;

            this.pollingTimer = setInterval(async () => {
                if(!this.isInternetConnected) {
                    clearInterval(this.pollingTimer);
                    return;
                }
                await this.getLiveVersion();
            }, this.interval);
        },
        async getLiveVersion() {
            try {
                const response = await this.$apiInstance.get(`/webversions/live/${this.role}`);
                if((response.status !== 200 && response.status !== 201)) throw new Error();
                if(!response.data || !response.data.version) throw new Error();
                
                if(localStorage.getItem('currentVersionManu') !== response.data.version) {
                    localStorage.setItem('currentVersionManu', response.data.version);
                    window.location.reload(true);
                }
            } catch (error) {
                console.log(error);
            }
        },
        checkHasAccessToken() {
            if(getAccessToken()) {
                window.checkIsLoggedIn({
                    isLoggedIn:true,
                    accessToken:getAccessToken(),
                    refreshToken:getRefreshToken(),
                });
            } else {
                window.checkIsLoggedIn({
                    isLoggedIn:false,
                    accessToken:null,
                    refreshToken:null,
                });
            }
        },
        setOnlineObserver() {
            window.addEventListener('online', ()=>{ 
                this.checkIsOnline(true);
            });
            window.addEventListener('offline', ()=>{
                this.checkIsOnline(false);
            });
        },
        async checkIsIpValid() {
            try {
                const result = await axios.post(`${process.env.VUE_APP_SERVERURL}/auth/nation/filter`,{},{headers: {
                    'x-cert-from': `${process.env.VUE_APP_SALT}`
                }})
                this.isIpValid = true;
            } catch(error) {
                console.log(error)
                this.isIpValid = false;
            }
        },
        async checkIsOnline(isOnline) {
            if(isOnline) {
                this.isInternetConnected = true;
                this.setLiveVersionObserver();
            } else {
                this.isInternetConnected = false;
                if(this.pollingTimer) {
                    clearInterval(this.pollingTimer);
                }
                await oneBtnDialog(this.$i18n.t('common_no_internet_connection_title'), this.$i18n.t('common_no_internet_connection_content'), false);
            }
        },
        handleDeviceChange(event) {
            if (event.matches) {
                // 디바이스가 변경되었을 때 수행할 작업을 여기에 작성합니다.
                // 컴포넌트를 다시 로드하거나, 상태를 갱신하는 등의 작업을 수행합니다.
            }
        },
        getRoute() {
            const routeArr = this.$route.path.split('/');
            return routeArr[1];
        },
        loadWebChatSDK() {
            const script = document.createElement('script');
            script.id = 'webchatSDK';
            script.async = true;
            script.src = 'https://webchat.certi.life/sdk/webchat.sdk.min.js';
            script.addEventListener('load', () => {
                new WebChat({
                    botId: '691adc2ebb1d17132f41ff37',
                    locale: 'ko'
                });
            });
            document.head.appendChild(script);
        },
    },
};
</script>
<style>
/*
  폰 하단 탭의 높이(홈 인디케이터 제외).

  세 곳이 같은 값을 봐야 한다 — 탭바 자신(MobileTabBar.vue), 본문 아래 자리를
  만드는 .mobile-tab-spacer, 그리고 탭을 가리지 않게 올려 둔 채팅 버튼.
  한 곳만 바뀌면 '탭이 본문을 덮거나' '빈 띠가 남는' 어긋남이 생긴다.

  값은 네이티브 탭바 구성을 그대로 옮긴 것이다: 위 12 + 아이콘 20 + 간격 8
  + 라벨 14 + 아래 16 = 70. MobileTabBar.vue 의 주석과 같이 봐야 한다.
  CSS 변수라 스코프트 스타일(MobileTabBar) 안에서도 상속으로 닿는다.
*/
:root {
  --mobile-tab-h: 70px;

  /*
    폰 상단 홈 바(.mobile-home-bar)의 높이.

    세 곳이 같은 값을 봐야 한다 — 바 자신, 본문 위 자리를 만드는
    common.scss 의 `.main-content { padding-top }`, 그리고 라벨 화면 셸 높이의
    폴백인 mobile-kit-tokens.scss 의 `--mk-app-header-h`.
    한 곳만 바뀌면 '헤더가 본문을 덮거나' '빈 띠가 남는' 어긋남이 생긴다 —
    하단 탭이 56 → 70 으로 늘었을 때 토큰만 안 따라와 실제로 그랬다(2026-09-04).

    값은 iOS 네이티브 네비바를 그대로 옮긴 것이다: UINavigationBar 표준 44pt.
    로고 높이 28px 도 같은 출처다(CardReleaseNaviTitleView 의 28pt).
    정렬만 웹 것을 유지한다 — 네이티브는 가운데, 여기는 왼쪽이다.

    PC 에서는 이 바를 그리지 않지만 변수는 :root 에 둔다 —
    이것을 참조하는 --mk-app-header-h 가 미디어쿼리 밖에서 쓰이기 때문이다.
  */
  --mobile-home-bar-h: 44px;
}

.signin-container .carousel__pagination-button::after {
  border-radius: 50% ;
  overflow: hidden ;
  width: 10px ;
  height: 10px ;
}

.finger-pointer{
    position: fixed;
    bottom: 50px;
    right: 70px;
    z-index: 1000;
    opacity: 0;
    pointer-events: none;
}

/* ==========================================================================
   모바일 (767px 이하)

   상단 홈 바와 하단 탭 자리. 두 요소 모두 position:fixed 라
   본문이 그 밑으로 깔리지 않게 위아래 여백을 잡아 준다.

   PC 는 이 블록 밖에 규칙이 없으므로 한 픽셀도 바뀌지 않는다.
   ========================================================================== */
@media screen and (max-width: 767px) {
  .mobile-home-bar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1030;
    height: var(--mobile-home-bar-h);
    display: flex;
    align-items: center;
    padding: 0 15px;
    background: #ffffff;
    border-bottom: 1px solid #e8ebed;
    cursor: pointer;
  }

  /*
    로고 높이도 iOS 네비바에서 가져왔다(CardReleaseNaviTitleView 의 28pt).
    폭은 자산 비율이 정한다 — certilogo.png 가 3012x712(4.230:1)라 118.5px 가 된다.
    iOS 는 아이콘·글자 두 조각을 붙여 116.1pt 라 2.4px 차이가 나는데,
    자산이 서로 달라서 생기는 차이라 높이를 맞추는 것 이상은 할 수 없다.
  */
  .mobile-home-logo {
    height: 28px;
    width: auto;
  }

  /*
    홈 바를 안 그리는 경우 그만큼의 여백도 없앤다.

    common.scss 의 `.main-content { padding-top: var(--mobile-home-bar-h) }`(폰 전용)은
    그 바가 있다는 전제로 넣은 값이라, 바만 숨기면 빈 띠가 남는다.
    공용 파일을 고치면 다른 화면까지 영향을 받으므로 여기서만 덮는다.

    클래스는 showMobileHomeBar 를 그대로 뒤집은 것이다(위 template).
    바를 숨기는 경우가 둘 — 구버전 앱(네이티브 바가 그림)과
    자기 앱바를 가진 화면(라벨 흐름) — 인데 둘 다 이 한 조건으로 덮인다.
  */
  .main-content.no-home-bar {
    padding-top: 0;
  }

  /*
    상단 여백은 애니메이션 없이 즉시 바꾼다.

    _navbar-vertical.scss 가 .main-content 에 `transition: $transition-base`
    (= all .2s ease-in-out)를 건다. PC 에서 사이드바가 열고 닫힐 때 본문이 부드럽게
    밀리라고 넣은 것인데, all 이라 padding-top 도 0.2초에 걸쳐 바뀐다.

    홈 바는 v-if 라 한 번에 사라지는데 여백만 천천히 줄면, 그 사이 44px 자리가 비어
    #app 의 밝은 회색이 드러난다. 라벨 목록 → QR 스캔처럼 검은 화면으로 넘어갈 때
    그 띠가 줄어들며 스캔 화면이 밀려 올라오는 게 그대로 보였다(실측: CSSTransition
    padding-top 44px → 0px, 200ms). 밝은 화면끼리는 같은 색이라 안 보였을 뿐 매번 일어났다.

    padding-top 만 0s 로 덮고 나머지는 원래 값을 그대로 둔다.
    앞의 all .2s ease-in-out 은 $transition-base 와 같은 값이어야 한다.

    선택자를 main.main-content 로 한 단계 세게 둔 이유: 원래 규칙(.main-content, .sidenav)이
    이 파일보다 뒤에 로드된다. 세기가 같으면 뒤에 온 쪽이 이겨 이 줄이 무시됐다(실측).
  */
  main.main-content {
    transition: all 0.2s ease-in-out, padding-top 0s;
  }

  /* 하단 탭 + 홈 인디케이터 높이만큼 본문 끝에 자리를 만든다.
     상단 여백(padding-top: var(--mobile-home-bar-h))은 common.scss 의 .main-content 규칙이 이미 잡는다. */
  .mobile-tab-spacer {
    height: calc(var(--mobile-tab-h) + env(safe-area-inset-bottom, 0px));
    flex: none;
  }

  /* 채팅 위젯이 탭 바를 가리지 않게 위로 올린다.
     origin/main 의 하단 탭에 있던 규칙을 그대로 되살린 것이다.
     탭 높이 + 14px 여유 — 예전 하드코딩(56+14=70)과 같은 간격이다. */
  #webchat-button-container {
    bottom: calc(var(--mobile-tab-h) + 14px + env(safe-area-inset-bottom, 0px)) !important;
  }
}
</style>